
import { useEffect, useRef, useState } from "react";
import { HomeAiCard } from "./HomeAiCard";
import { HomeRoadsideCard } from "./HomeRoadsideCard";
/* Carousel holding the two RentShield cards — on-rent insurance and roadside assistance — as
   cross-fading slides in one section. Navigation lives on an in-card toggle (Insurance /
   Roadside) at the bottom-left of each card; there are no corner arrows or dots. The RentID
   card stays as its own separate section below. */
export function HomeShieldCarousel({ cobrand = false } = {}) {
    const [active, setActive] = useState(0);
    const [visible, setVisible] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setVisible(true);
                observer.disconnect();
            }
        }, { threshold: 0.2 });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
    return (<div ref={ref} className="relative mt-8 sm:mt-12 lg:mt-16" role="group" aria-roledescription="carousel" aria-label="RentShield features">
      {/* Both cards occupy the same grid cell and cross-fade; the taller card sets the height. */}
      <div className="grid">
        <div className="[grid-area:1/1] transition-opacity duration-500 ease-out" style={{ opacity: active === 0 ? 1 : 0, pointerEvents: active === 0 ? "auto" : "none" }} aria-hidden={active !== 0}>
          <HomeAiCard active={active} onSelect={setActive} forceReveal={visible} flushTop cobrand={cobrand}/>
        </div>
        <div className="[grid-area:1/1] transition-opacity duration-500 ease-out" style={{ opacity: active === 1 ? 1 : 0, pointerEvents: active === 1 ? "auto" : "none" }} aria-hidden={active !== 1}>
          <HomeRoadsideCard active={active} onSelect={setActive} forceReveal={visible} cobrand={cobrand}/>
        </div>
      </div>
    </div>);
}
